/**
 * System pages — whole-page layouts mounted by host routes
 * (BlogDetail, WikiDetail/Index, VideoDetail/Index, Series, Channel,
 * Library, MicroListing). Each consumes one or more runtime adapters
 * and renders the canonical page experience. Theme bundles can
 * override any of these via the resolver's
 * {@code system}/{@code primitives} maps.
 */

// Blog
export { BlogDetailLayout, type BlogDetailLayoutProps } from './BlogDetailLayout';
export {
  ArticleCardImageLed,
  ArticleCardMinimal,
  ArticleCardMagazine,
  resolveArticleCard,
  type ArticleCardVariant,
  type ArticleCardProps,
} from './ArticleCardVariants';

// Wiki
export { WikiTreeNav, type WikiTreeNavProps } from './WikiTreeNav';
export { WikiPageHeader, type WikiPageHeaderProps } from './WikiPageHeader';
export { WikiDetailLayout, type WikiDetailLayoutProps } from './WikiDetailLayout';
export { WikiIndexLayout, type WikiIndexLayoutProps } from './WikiIndexLayout';
export { resolveWikiDetailVariant, type WikiDetailVariant } from './WikiDetailVariants';
export { resolveWikiTreeVariant, type WikiTreeVariant } from './WikiTreeVariants';

// Video / channels / series
export { VideoCard, type VideoCardProps, type VideoCardVariant } from './VideoCard';
export { VideoRail, type VideoRailProps } from './VideoRail';
export { VideoDetailLayout, type VideoDetailLayoutProps } from './VideoDetailLayout';
export { CommentsBlock, type CommentsBlockProps } from './CommentsBlock';
export { resolveVideoDetailVariant, type VideoDetailVariant } from './VideoDetailVariants';
export { VideoIndexLayout, type VideoIndexLayoutProps } from './VideoIndexLayout';
export { VideoActionGroup, type VideoActionGroupProps } from './VideoActionGroup';
export { ChannelCard, type ChannelCardProps, type ChannelCardVariant } from './ChannelCard';
export { ChannelChip, type ChannelChipProps } from './ChannelChip';
export { SyntheticChannelChip, type SyntheticChannelChipProps } from './SyntheticChannelChip';
export { ChannelDetailLayout, type ChannelDetailLayoutProps } from './ChannelDetailLayout';
export { ChannelDiscoveryLayout, type ChannelDiscoveryLayoutProps } from './ChannelDiscoveryLayout';
export { EpisodeCard, type EpisodeCardProps, type EpisodeListStyle } from './EpisodeCard';
export { SeriesDetailLayout, type SeriesDetailLayoutProps } from './SeriesDetailLayout';
export { resolveSeriesDetailVariant, type SeriesDetailVariant } from './SeriesDetailVariants';
export { SeriesPlaylistSidebar, type SeriesPlaylistSidebarProps } from './SeriesPlaylistSidebar';
export { SeriesPlayerLayout, type SeriesPlayerLayoutProps } from './SeriesPlayerLayout';
export { PlaylistControls, type PlaylistControlsProps } from './PlaylistControls';
export { UpNextFilterPills, type UpNextFilterPillsProps } from './UpNextFilterPills';

// Misc
export { HistoryWriter, type HistoryWriterProps } from './HistoryWriter';
export { LibraryClient, type LibraryClientProps, type LibraryTab } from './LibraryClient';
export { MediaTemplateBlocks, type MediaTemplateBlocksProps } from './MediaTemplateBlocks';
export { MicroListingLayout, type MicroListingLayoutProps } from './MicroListingLayout';

// Raw HTML escape hatch — use `RichText` with `format='raw-html'`.
// (HtmlBlock was absorbed into RichText as a third render mode.)
